import React from "react";
import cn from 'classnames';
import "meta/extensions/icons";
const IconStack = (props) => {
    let { className, children } = props;
    const _class = cn([`fa-stack`, className]);
    return (<span className={_class}>
            {children}
        </span>);
};
export default IconStack;
